<template>
    <div id="app">
        <div class="container auth-container">
            <div class="columns is-centered">
                <div class="column is-5">
                    <div class="columns is-centered">
                        <div class="column is-12">
                            <router-view/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core';

export default {
    created() {
        library.add(faCheckCircle);
    },
}
</script>
